import React from 'react';
import { X } from 'lucide-react';
import { useEscapeClose } from '../../../../hooks/useEscapeClose';
import { LEAD_DETAIL_BTN_OUTLINE, LEAD_DETAIL_INPUT_CLASS } from './leadDetailStyles';

const LINK_MODAL_BTN_PRIMARY =
  'inline-flex h-9 items-center justify-center gap-2 shrink-0 rounded-md bg-pipedrive-blue px-3.5 text-sm font-semibold text-white hover:bg-blue-700 disabled:opacity-40 transition-colors';

/** Modal zum Einfügen eines Links in den Notizen-Editor (Tab „Notizen“). */
export function NoteLinkModal({
  open,
  text,
  url,
  onTextChange,
  onUrlChange,
  onClose,
  onSave,
}: {
  open: boolean;
  text: string;
  url: string;
  onTextChange: (value: string) => void;
  onUrlChange: (value: string) => void;
  onClose: () => void;
  onSave: () => void;
}) {
  const canSave = Boolean(url.trim());
  useEscapeClose(onClose, open);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSave) return;
    onSave();
  };

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="bg-app-surface rounded-xl shadow-xl border border-app-border w-full max-w-md"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="note-link-modal-title"
      >
        <div className="flex items-center justify-between gap-3 border-b border-app-border px-5 py-4">
          <h3 id="note-link-modal-title" className="text-sm font-semibold text-app-text">
            Link einfügen
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-8 w-8 items-center justify-center rounded text-app-text-subtle hover:bg-app-hover"
            aria-label="Schließen"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-5">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-app-text mb-1">Text</label>
              <input
                type="text"
                value={text}
                onChange={(e) => onTextChange(e.target.value)}
                className={LEAD_DETAIL_INPUT_CLASS}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-app-text mb-1">Link</label>
              <input
                type="url"
                value={url}
                onChange={(e) => onUrlChange(e.target.value)}
                placeholder="https://"
                autoFocus
                className={LEAD_DETAIL_INPUT_CLASS}
              />
            </div>
          </div>
          <div className="flex justify-end gap-2 mt-5">
            <button type="button" onClick={onClose} className={LEAD_DETAIL_BTN_OUTLINE}>
              Abbrechen
            </button>
            <button type="submit" disabled={!canSave} className={LINK_MODAL_BTN_PRIMARY}>
              Speichern
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
